export const COLORS = {
  gold: '#FCDBC1',
  black: '#4C4C4C',
  silver: '#F0F0F0',
  midnightgreen: '#5F7170',
  graphite: '#4C4C4C',
  sierrablue: '#BFDAF7',
  spaceblack: '#505150',
  rosegold: '#B76E79',
  skyblue: '#87CEEB',
  green: '#008000',
  starlight: '#f4edc6',
  pink: '#FFC0CB',
  spacegray: '#4C4C4C',
  blue: '	#00008B',
  red: '#d30000',
  yellow: '#FFFF00',
  purple: '#A020F0',
  midnight: '#191970',
  coral: '#FF7F50',
};
